import { k } from "../core/kaplay";
import { addButton, addTitle, addUiRoot } from "../ui/layout";

export function resultsScene({ reason = "finished" }: { reason?: string } = {}) {
    const ui = addUiRoot();
    addTitle(ui, "Results", -200, 96);
    addTitle(ui, `Run ended: ${reason}`, -80, 40);
    addButton(ui, "Ride again", 60, () => k.go("mountain"));
    addButton(ui, "Menu", 180, () => k.go("menu"));
}
